if not App.angularApp?
    return

App.angularApp.directive 'mfDataViewHeight', ['$window', '$rootScope', ($window, $rootScope) ->
    return {
        link: (scope, ele, attrs) ->
            # This directive can only be used with the data page sidebar.
            # The custom logic in this directive will break things if you try to use it anywhere else.

            calculatePixels = () ->
                if not (ele[0].children and (scope.formsData?.length or scope.formsData?.length))
                    $rootScope.$broadcast('data-view:resized')
                    return

                # There is this much padding between elements in the div that needs to be accounted for
                padding = 37
                container_height = ele[0].clientHeight - padding

                # if we don't get a height, bail out so we don't break stuff
                if container_height <= 0
                    $rootScope.$broadcast('data-view:resized')
                    return

                children_height = 0
                for child in ele[0].children
                    child = $(child)
                    if not child.hasClass('forms-table-container') and
                            not child.hasClass('maps-table-container')
                        children_height += child[0].clientHeight

                available_height = container_height - children_height
                handleTableHeight(available_height)


            handleTableHeight = (available) ->
                form = 49 + scope.formsData.length * 29

                map = 49
                for elem in scope.mapsData
                    if elem.layer_title?.length > 16
                        map += 54
                    else
                        map += 27

                # This is to keep the data view maps table from collapsing when there's only a message in it saying that there's no data
                if not scope.mapsData.length
                    map += 27

                half = available / 2

                if map >= half and form >= half
                    # make sure there's always enough room for one row
                    form_height = Math.max(half, 78)
                    map_height = Math.max(half, 76)
                else
                    form_height = if form > half then available - map else form
                    map_height = if map > half then available - form else map

                scope.form_table_style = height: form_height
                scope.map_table_style = height: map_height

                $rootScope.$broadcast('data-view:resized')

            # Need to initialize on load
            calculatePixels()

            # resize tables after window resize finishes
            scope.$on 'resizable:resized', () ->
                calculatePixels()
    }
]
